module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-shirts-medium-7eebd2ce6977f197f51073f7049d8af0.jpg";